<template>
  <div
    class="modal fade"
    id="modal"
    ref="modal"
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg" style="border-radius: 16px;">

        <div class="modal-header border-0 pb-2 justify-content-between align-items-center">
          <h5 class="modal-title fw-bold text-dark">
            <i class="fa-solid fa-bell-concierge me-2 text-theme"/>
            {{ $t('Table Management') }}
            <span class="text-primary">
              {{ name }}
            </span>
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body px-4 pb-4">
          <!--
            แท็บ ลูกค้า walk-in / จองโต๊ะ — แพ็กไม่มี feature_reservations เหลือแค่ walk-in จึงซ่อนแถบแท็บทั้งแถบ
            (API กั้น tables/{id}/reserve ไว้แล้ว · การจองที่ค้างจากตอนมีแพ็ก ยังเปิด/ยกเลิกได้จาก ModalTableReserved)
          -->
          <ul v-if="$hasFeature('feature_reservations')" class="nav nav-pills nav-justified mb-4" id="tableActionTabs" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link fw-bold rounded-pill"
                :class="{'active': type == 'walk_in'}"
                @click="() => {type = 'walk_in'}"
              >
                <i class="fa-solid fa-person-walking me-1"/>
                {{ $t('Walk-in Customer') }}
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link fw-bold rounded-pill"
                :class="{'active': type == 'reserve'}"
                @click="() => {type = 'reserve'}"
              >
                <i class="fa-regular fa-calendar-check me-1"/>
                {{ $t('Reserve Table') }}
              </button>
            </li>
          </ul>

          <div
            v-if="type == 'walk_in'"
          >
            <p class="text-muted small mb-3">
              {{ $t('Specify number of guests') + ' (Pax)' }}
            </p>

            <div class="mb-3">
              <input
                type="number" class="form-control form-control-lg fw-bold shadow-none text-center text-primary"
                v-model.trim="v$.form.walk_in.customer_count.$model"
                :min="v$.form.walk_in.customer_count.minValue.$params.min"
                :max="v$.form.walk_in.customer_count.maxValue.$params.max"
                style="font-size: 2rem; border-radius: 12px; background-color: #f8f9fa;"
                readonly
              >
            </div>

            <div class="row g-2 mb-3">
              <div class="col-4" v-for="num in 6">
                <button
                  class="btn w-100 py-2 fw-bold fs-5 rounded-3"
                  :class="[form.walk_in.customer_count == num? 'btn-theme  text-white':'btn-outline-secondary']"
                  @click="() => {
                    form.walk_in.customer_count = num;
                  }"
                >
                  {{ num }}
                </button>
              </div>
            </div>

            <div class="d-flex justify-content-center align-items-center gap-3">
              <button
                class="btn btn-secondary rounded-circle shadow-sm"
                style="width: 45px; height: 45px;"
                :disabled="form.walk_in.customer_count < v$.form.walk_in.customer_count.minValue.$params.min || form.walk_in.customer_count == ''"
                @click="() => {
                  if (form.walk_in.customer_count < v$.form.walk_in.customer_count.minValue.$params.min || form.walk_in.customer_count == '') return;
                  form.walk_in.customer_count = parseFloat(form.walk_in.customer_count || 0) - 1;
                }"
              >
                <i class="fa-solid fa-minus"/>
              </button>
              <span class="text-muted small">{{ $t('Custom') }}</span>
              <button
                class="btn btn-secondary rounded-circle shadow-sm"
                style="width: 45px; height: 45px;"
                :disabled="form.walk_in.customer_count >= v$.form.walk_in.customer_count.maxValue.$params.max"
                @click="() => {
                  if (form.walk_in.customer_count > v$.form.walk_in.customer_count.maxValue.$params.max) return;
                  form.walk_in.customer_count = parseFloat(form.walk_in.customer_count || 0) + 1;
                }"
              >
                <i class="fa-solid fa-plus"/>
              </button>
            </div>

            <div class="mt-4">
              <label class="form-label small text-muted fw-bold">
                <i class="fa-solid fa-id-card me-1"/>{{ $t('Member') }}
                <span class="fw-normal">({{ $t('optional') }})</span>
              </label>
              <member-select
                :dropdown-parent="'#modal'"
                @selected="onSelectMember"
                @cleared="onClearMember"
              />
            </div>
          </div>
          <div
            v-else
          >
            <div class="mb-3">
              <label class="form-label small text-muted fw-bold">
                {{ $t('Customer Name / Phone Number') }}
              </label>
              <div class="input-group">
                <span class="input-group-text bg-light"><i class="fa-solid fa-user"/></span>
                <input
                  type="text"
                  class="form-control shadow-none"
                  :placeholder="$t('Customer Name')"
                  v-model.trim="v$.form.reserve.name.$model"
                >
                <input
                  type="tel"
                  class="form-control shadow-none"
                  :placeholder="$t('Phone Number')"
                  v-model.trim="v$.form.reserve.telephone.$model"
                >
                <div v-for="error of v$.form.reserve.name.$errors"
                  class="d-block invalid-feedback"
                  :key="error.$uid"
                >
                  {{ error.$message }}
                </div>
                <div v-for="error of v$.form.reserve.telephone.$errors"
                  class="d-block invalid-feedback"
                  :key="error.$uid"
                >
                  {{ error.$message }}
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-6">
                <label class="form-label small text-muted fw-bold">
                  {{ $t('Date and Time') }}
                </label>
                <input
                  type="datetime-local"
                  class="form-control shadow-none"
                  v-model.trim="v$.form.reserve.reserve_at.$model"
                >
                <div v-for="error of v$.form.reserve.reserve_at.$errors"
                  class="d-block invalid-feedback"
                  :key="error.$uid"
                >
                  {{ error.$message }}
                </div>
              </div>
              <div class="col-6">
                <label class="form-label small text-muted fw-bold">
                  {{ $t('Number of guests') + ' (Pax)' }}
                </label>
                <div class="input-group">
                  <span class="input-group-text bg-light">
                    <i class="fa-solid fa-users"/>
                  </span>
                  <input
                    type="number"
                    class="form-control shadow-none text-center"
                    v-model.trim="v$.form.reserve.pax.$model"
                    :min="v$.form.reserve.pax.minValue.$params.min"
                    :max="v$.form.reserve.pax.maxValue.$params.max"
                  >
                  <div v-for="error of v$.form.reserve.pax.$errors"
                    class="d-block invalid-feedback"
                    :key="error.$uid"
                  >
                    {{ error.$message }}
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-4">
              <label class="form-label small text-muted fw-bold">
                {{ $t('Note') }}
              </label>
              <input
                type="text"
                class="form-control shadow-none"
                v-model.trim="v$.form.reserve.note.$model"
                :placeholder="$t('note') + '...'"
              >
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 pt-0 px-4 pb-4">
          <ladda
            v-if="type == 'walk_in'"
            text="Confirm Open Table"
            :btn-class="'btn btn-theme w-100 py-3 fw-bold fs-5 text-white'"
            style="border-radius: 12px; box-shadow: 0 4px 10px rgba(234, 100, 6, 0.3);"
            :loading="loadingSave"
            icon="<i class='fa-solid fa-check-circle'></i>"
            :disabled="v$.form.walk_in.$invalid"
            @click="handleOpen"
          />
          <ladda
            v-if="type == 'reserve'"
            text="Save Reservation"
            :btn-class="'btn btn-theme w-100 py-3 fw-bold fs-5 text-white'"
            style="border-radius: 12px; box-shadow: 0 4px 10px rgba(234, 100, 6, 0.3);"
            :loading="loadingSave"
            icon="<i class='fa-solid fa-calendar-plus'></i>"
            :disabled="v$.form.reserve.$invalid"
            @click="handleReserve"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { POSTables } from '@/services/endpoint/pos.service';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import Ladda from '@/plugins/Ladda.vue';
import MemberSelect from '@/components/shared/MemberSelect.vue';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.form)
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
  },
  data() {
    let vm = this;
    return {
      loadingSave: false,
      type: 'walk_in',
      form: {
        walk_in: {
          customer_count: 1,
          customer_id: null
        },
        reserve: {
          name: '',
        }
      }
    }
  },
  components: {
    Ladda,
    MemberSelect
  },
  methods: {
    onSelectMember(member) {
      this.form.walk_in.customer_id = member.id;
    },
    onClearMember() {
      this.form.walk_in.customer_id = null;
    },
    async handleOpen() {
      this.loadingSave = true;
      this.v$.form.walk_in.$touch();
      if(this.v$.form.walk_in.$invalid) {
        this.loadingSave = false;
        return;
      }

      await POSTables.open(this.id, this.form.walk_in).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Open Table Success!'));
        $(this.$refs.modal).modal('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) {
          this.$toast.warn(err?.response?.data?.message);
        }
        this.loadingSave = false;
      });
    },
    async handleReserve() {
      this.loadingSave = true;
      this.v$.form.reserve.$touch();
      if(this.v$.form.reserve.$invalid) {
        this.loadingSave = false;
        return;
      }

      await POSTables.reserve(this.id, this.form.reserve).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Open Table Success!'));
        $(this.$refs.modal).modal('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) {
          this.$toast.warn(err?.response?.data?.message);
        }
        this.loadingSave = false;
      });
    },
  },
  async mounted() {
    $(this.$refs.modal).modal('show');

    // $(this.$refs.modal).on('shown.bs.modal',async () => {
    //   this.loading = true;
    //   try {
    //     this.loading = false;
    //   } catch (err) {
    //     console.log(err, 'err');
    //   }
    // });

    $(this.$refs.modal).on('hidden.bs.modal', () => {
      this.$emit('close')
    });
  },
  computed: {
    totalUsed() {
      return this.form.allocations.reduce((sum, value) => {
        return sum + (value.actual_quantity*1);
      }, 0);
    }
  }
}
</script>
